// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__PRltb","preloader-rotate":"Spinner_preloader-rotate__Dq5hx"};